import React from 'react';
import Boot from './containers/Boot';
import './app.global.css';
import './fonts.css';

export default () => <Boot />

